import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useCreditsRealtime = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!user) return;

    // Subscribe to real-time changes on user_credits table
    const channel = supabase
      .channel('user-credits-changes')
      .on(
        'postgres_changes',
        {
          event: '*', // Listen to all events (INSERT, UPDATE, DELETE)
          schema: 'public',
          table: 'user_credits',
          filter: `user_id=eq.${user.id}`,
        },
        (payload) => {
          console.log('🔄 Real-time credit update:', payload.eventType, 'for user:', user.id);
          
          // Instantly update the cache with new data - NO INVALIDATION to prevent refetch loops
          if (payload.eventType === 'UPDATE' || payload.eventType === 'INSERT') {
            queryClient.setQueryData(['subscription-status', user.id], payload.new);
            console.log('✅ Updated subscription cache with real-time data');
          } else if (payload.eventType === 'DELETE') {
            queryClient.setQueryData(['subscription-status', user.id], null);
            console.log('🗑️ Cleared subscription cache due to deletion');
          }
          
          // REMOVED: queryClient.invalidateQueries to prevent excessive API calls
          // Real-time updates provide fresh data, no need to refetch from API
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user, queryClient]);
};